import React, { useMemo, useState } from 'react'

import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import { isFunction, snakeCase } from 'lodash'
import { Divider, message, notification } from 'antd'

import { isValid } from '../../../utils/validators'
import { SCHOOL_PERIOD_VALIDATORS, SchoolPeriod } from '../../../utils/entities/schoolPeriod'
import QuickDualDatePickers from '../../../Components/institution/Quotas/shared/QuickDualDatePickers'
import { isOptimistic } from '../../../utils'
import FormFooter from '../../../Components/antd/Forms/FormFooter'

export const BODY_STYLE = { display: 'flex', flexDirection: 'column', height: '93%', width: '100%' }
export const SELECT_STYLE = { width: '200px' }

message.config({
  top: 20,
  duration: 3,
  maxCount: 1,
  placement: 'topRight'
})

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const SchoolPeriodForm = ({ data, disabled, onDelete, onSubmit, onCancel, t }) => {
  const [formData, setFormData] = useState(new SchoolPeriod(data))

  const handleSubmit = event => {
    const errors = isValid(formData, SCHOOL_PERIOD_VALIDATORS)

    if (errors.keys.length > 0) {
      const errorMessages = t('common_form.error_fields', {
        fields: errors.keys.map(key => t('common.' + snakeCase(key))).join(', ')
      })

      notification.error({ message: errorMessages })
    } else if (formData.startDate > formData.endDate) {
      message.error({ message: t('common_form.error_dates') })
    } else {
      onSubmit(new SchoolPeriod(formData))
    }
  }

  const handleDatesChange = (dates, _) => setFormData(formData => ({ ...formData, startDate: dates[0], endDate: dates[1] }))

  const isSubmitDisabled = useMemo(() => (
    formData.startDate === null || formData.endDate === null || disabled
  ), [formData.startDate, formData.endDate, disabled])

  return (
    <div className='school-period-form'>
      <div className='flex-column w-100 pd-12'>
        <QuickDualDatePickers
          startDate={formData.startDate}
          endDate={formData.endDate}
          period={formData.period}
          disabled={disabled}
          onDatesChange={handleDatesChange}
        />
      </div>

      <Divider className='divider-0' />

      <FormFooter
        cancel={{ text: t('modal.cancel_button'), disabled }}
        remove={!isOptimistic(formData) && isFunction(onDelete) && {
          popover: { content: t('school_period_form.buttons.delete'), title: t('common.delete') },
          tooltip: t('common.delete')
        }}
        submit={{
          disabled: isSubmitDisabled,
          text: t('modal.ok_button.save'),
          tooltip: isSubmitDisabled && t('form_modal.add_button.disabled_tooltip', {
            fields: [
              t('common.start_date'),
              t('common.end_date')
            ].join(', ')
          })
        }}
        onCancel={onCancel}
        onDelete={onDelete}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export default connect(mapStateToProps)(SchoolPeriodForm)
